import React from "react";
import { Button, DatePicker, Form, Input, Select, Table } from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
import AvatarIcon from "../../../../../../../assets/images/avatar.png";
import AvatarVIPIcon from "../../../../../../../assets/images/avatar-vip.png";
import Validator from "../../../../../utils/formValidator";
import { GAPersonalProfileLinkToPremium } from "../../../../../ga/personalCenter";

const ProfileRender = ({
  countryList,
  dataSource,
  tableColumns,
  profileObj,
  isVIP,
  changeInfoName,
  submitting,
  handleChangeInfoName,
  handleClickChangeProfileBtn,
  handleSubmitBtnHide,
}) => {
  const { t } = useTranslation(["personalCenterProfile", "common"]);

  const nameForm = Form.useForm()[0];
  return (
    <div className="profile">
      <h4 className="fw-bold mb-4">{t("title")}</h4>
      <div className="mb-5">
        {isVIP ? <img src={AvatarVIPIcon} className="avatar me-4" alt="avatar" /> : <img src={AvatarIcon} alt="avatar" className="avatar me-4" />}
        {!isVIP && (
          <Link to="/purchase" onClick={GAPersonalProfileLinkToPremium}>
            <Button type="primary" className="premium-btn fw-bolder">
              {t("premiumBtn")}
            </Button>
          </Link>
        )}
      </div>
      {profileObj ? (
        <>
          <Form
            form={nameForm}
            className="mb-0 position-relative"
            layout="vertical"
            name="name-form"
            initialValues={{
              name: profileObj.nickname ? profileObj.nickname : t("common:anonymous"),
            }}
            onFinish={data => handleClickChangeProfileBtn(data, "name")}
            onBlur={() => handleSubmitBtnHide(nameForm)}
          >
            <Form.Item
              label={t("common:name")}
              name="name"
              rules={[
                {
                  required: true,
                  validator: Validator.nameValidator,
                },
              ]}
            >
              <Input placeholder={t("common:name")} onFocus={() => handleChangeInfoName("name")} onBlur={() => {}} />
            </Form.Item>
            <Form.Item className={`submit-form position-absolute ${changeInfoName === "name" ? "active" : ""}`}>
              <Button type="primary" className="submit-btn" loading={submitting} htmlType="submit">
                {t("common:confirm")}
              </Button>
            </Form.Item>
          </Form>
          <Form
            className="mb-0 position-relative"
            layout="vertical"
            name="email-form"
            initialValues={{
              email: profileObj.email,
            }}
          >
            <Form.Item label={t("common:email")} name="email">
              <Input placeholder={t("common:email")} disabled />
            </Form.Item>
          </Form>
          <Form
            className="mb-0 position-relative"
            layout="vertical"
            name="country-form"
            initialValues={{
              country: profileObj.country ? profileObj.country : "CN",
            }}
            onFinish={data => handleClickChangeProfileBtn(data, "country")}
          >
            <Form.Item label={t("common:country")} name="country">
              <Select
                options={countryList}
                suffixIcon={
                  <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L6.29289 6.29289C6.68342 6.68342 7.31658 6.68342 7.70711 6.29289L13 1" stroke="#9F9FA1" strokeWidth="1.5" />
                  </svg>
                }
                showSearch
                optionFilterProp="label"
                onChange={() => handleChangeInfoName("country")}
              ></Select>
            </Form.Item>
            <Form.Item className={`submit-form position-absolute ${changeInfoName === "country" ? "active" : ""}`}>
              <Button type="primary" className="submit-btn" loading={submitting} htmlType="submit">
                {t("common:confirm")}
              </Button>
            </Form.Item>
          </Form>
          <Form
            className="mb-5 position-relative"
            layout="vertical"
            name="birthday-form"
            initialValues={{
              birthday: profileObj.birthday ? moment(profileObj.birthday) : moment("1995-01-01"),
            }}
            onFinish={data => handleClickChangeProfileBtn(data, "birthday")}
          >
            <Form.Item label={t("common:birthday")} name="birthday">
              <DatePicker
                className="date-picker w-100"
                placeholder={t("common:birthday")}
                suffixIcon={null}
                allowClear={false}
                showToday={false}
                onChange={() => handleChangeInfoName("birthday")}
                disabledDate={current => current >= moment().startOf("day")}
              />
            </Form.Item>
            <Form.Item className={`submit-form position-absolute ${changeInfoName === "birthday" ? "active" : ""}`}>
              <Button type="primary" className="submit-btn" loading={submitting} htmlType="submit">
                {t("common:confirm")}
              </Button>
            </Form.Item>
          </Form>
        </>
      ) : null}
      <h4 className="fw-bold mb-4">{t("orderInfoTitle")}</h4>
      <Table dataSource={dataSource} columns={tableColumns} bordered pagination={false} locale={{ emptyText: <span> {t("noData")}</span> }}></Table>
    </div>
  );
};

export default ProfileRender;
